/*
  Section 4 (service-icons-inova) below 1024: the source's flickity carousel, one card per view.
  Theme 98.0, 24.9.2026. Measured and read in theme/design/regimes/out/review-si-98/ (carousel.txt,
  refcss-dots.txt, refcss-flickity.txt); the source code quoted from
  review-stli-14.9/source-js/bytes-20.9/vendor.js (flickity 3) and theme.js (CarouselElement).

  The source: `new Flickity(el, { watchCSS, prevNextButtons: false, adaptiveHeight: true,
  wrapAround: true, rightToLeft: theme.config.rtl })` on .text-with-icons, active only while its
  `:after { content: "flickity" }` - below 1024. Defaults: cellAlign center, pageDots, draggable
  '>1', dragThreshold 3, selectedAttraction .025, friction .28, percentPosition.

  The same model here, without moving any node: the row is the viewport and each card is placed
  by its own transform, so the section's structural selectors keep matching. x is flickity's
  slider position (forward is negative); a card's screen offset from the inline start is
  cellX + wrapShift + e + cursor, mirrored in RTL.

  Reduced motion: select jumps without the glide - the same in-between state as section 2's pager
  (the source keeps gliding; the open question is Elad's since 14.9).
*/
(function () {
  var ROW = '.section-content-wrapper > .group-block > .group-block-content';
  var MQ = window.matchMedia('(max-width: 1023px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ATTRACTION = 0.025;
  var FRICTION = 0.28;
  var THRESHOLD = 3;

  function modulo(a, b) {
    return ((a % b) + b) % b;
  }

  function Carousel(root) {
    this.root = root;
    this.row = root.querySelector(ROW);
    this.active = false;
    if (!this.row) return;
    this.cells = Array.prototype.filter.call(this.row.children, function (c) {
      return c.classList.contains('group-block');
    });
    this.onChange = this.update.bind(this);
    MQ.addEventListener('change', this.onChange);
    this.update();
  }

  Carousel.prototype.update = function () {
    if (MQ.matches && this.cells.length > 1) this.activate();
    else this.deactivate();
  };

  Carousel.prototype.activate = function () {
    if (this.active) return;
    this.active = true;
    var self = this;
    this.rtl = window.getComputedStyle(this.row).direction === 'rtl';
    this.n = this.cells.length;
    this.index = 0;
    this.x = 0;
    this.velocity = 0;
    this.animating = false;
    this.pointerDown = false;
    this.dragging = false;

    this.row.classList.add('svc-carousel');
    this.row.setAttribute('tabindex', '0');

    this.holder = document.createElement('div');
    this.holder.className = 'svc-dots';
    this.dots = this.cells.map(function (c, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'svc-dot';
      b.setAttribute('aria-label', 'הצגת שקופית ' + (k + 1));
      self.holder.appendChild(b);
      return b;
    });
    this.row.parentNode.insertBefore(this.holder, this.row.nextSibling);

    this.onDots = function (e) {
      var k = self.dots.indexOf(e.target);
      if (k !== -1) self.select(k);
    };
    this.onKey = function (e) {
      var a = document.activeElement;
      if (a !== self.row && self.dots.indexOf(a) === -1) return;
      if (e.key === 'ArrowLeft') self.select(self.index + (self.rtl ? 1 : -1), true);
      else if (e.key === 'ArrowRight') self.select(self.index + (self.rtl ? -1 : 1), true);
    };
    this.onDown = this.pointerStart.bind(this);
    this.onMove = this.pointerMove.bind(this);
    this.onUp = this.pointerUp.bind(this);
    this.onResize = function () {
      if (!self.active) return;
      self.measure();
      self.x = -self.target(self.index);
      self.velocity = 0;
      self.render();
      self.setHeight();
    };
    this.onClick = function (e) {
      if (self.preventClick) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    this.holder.addEventListener('click', this.onDots);
    this.root.addEventListener('keydown', this.onKey);
    this.row.addEventListener('pointerdown', this.onDown);
    this.row.addEventListener('click', this.onClick, true);
    window.addEventListener('resize', this.onResize);

    this.measure();
    this.x = -this.target(0);
    this.render();
    this.markSelected();
    this.setHeight();
  };

  Carousel.prototype.deactivate = function () {
    if (!this.active) return;
    this.active = false;
    this.animating = false;
    this.pointerDone();
    this.holder.remove();
    this.root.removeEventListener('keydown', this.onKey);
    this.row.removeEventListener('pointerdown', this.onDown);
    this.row.removeEventListener('click', this.onClick, true);
    window.removeEventListener('resize', this.onResize);
    this.row.classList.remove('svc-carousel', 'is-pointer-down');
    this.row.removeAttribute('tabindex');
    this.row.style.height = '';
    this.cells.forEach(function (c) {
      c.style.transform = '';
      c.classList.remove('is-selected');
      c.removeAttribute('aria-hidden');
    });
  };

  // `getSize` + `_positionCells` + `_getGapCells`; cellAlign center puts the cursor at half the view.
  Carousel.prototype.measure = function () {
    var w = this.row.clientWidth || 1;
    var sum = 0;
    var self = this;
    this.w = w;
    this.cursor = w / 2;
    this.cellX = [];
    this.outer = [];
    this.cells.forEach(function (c) {
      var o = c.getBoundingClientRect().width;
      self.cellX.push(sum);
      self.outer.push(o);
      sum += o;
    });
    this.width = sum;
    this.before = this.gapCells(this.cursor, this.n - 1, -1);
    this.after = this.gapCells(w - this.cursor, 0, 1);
  };

  Carousel.prototype.gapCells = function (gap, k, dir) {
    var list = [];
    while (gap > 0 && k >= 0 && k < this.n) {
      list.push(k);
      gap -= this.outer[k];
      k += dir;
    }
    return list;
  };

  Carousel.prototype.target = function (k) {
    return this.cellX[k] + this.outer[k] / 2;
  };

  // `getSlideDistance`: wrapAround adds a whole loop per lap.
  Carousel.prototype.distance = function (x, k) {
    var i = modulo(k, this.n);
    return x - (this.target(i) + this.width * Math.floor(k / this.n));
  };

  // `positionSlider` + `shiftWrapCells` + `setTranslateX` (percent of the view, to .01).
  Carousel.prototype.render = function () {
    var e = modulo(this.x, this.width) - this.width;
    var shift = [];
    var gap = this.cursor + e;
    var self = this;
    this.before.forEach(function (k) {
      shift[k] = gap > 0 ? -1 : 0;
      gap -= self.outer[k];
    });
    gap = this.w - (e + this.width + this.cursor);
    this.after.forEach(function (k) {
      shift[k] = gap > 0 ? 1 : 0;
      gap -= self.outer[k];
    });
    var side = this.rtl ? -1 : 1;
    var slider = Math.round(((e + this.cursor) / this.w) * 10000) / 100;
    this.cells.forEach(function (c, k) {
      var cell = Math.round(((self.cellX[k] + (shift[k] || 0) * self.width) / self.w) * 10000) / 100;
      c.style.transform = 'translateX(' + side * (slider + cell) + '%)';
    });
  };

  // `setGallerySize` with adaptiveHeight: the view takes the selected card's height.
  Carousel.prototype.setHeight = function () {
    this.row.style.height = this.cells[this.index].getBoundingClientRect().height + 'px';
  };

  Carousel.prototype.markSelected = function () {
    var self = this;
    this.cells.forEach(function (c, k) {
      var on = k === self.index;
      c.classList.toggle('is-selected', on);
      if (on) c.removeAttribute('aria-hidden');
      else c.setAttribute('aria-hidden', 'true');
    });
    this.dots.forEach(function (d, k) {
      var on = k === self.index;
      d.classList.toggle('is-selected', on);
      if (on) d.setAttribute('aria-current', 'step');
      else d.removeAttribute('aria-current');
    });
  };

  // `select` + `_wrapSelect`: the short way round, unless the drag chose the lap itself.
  Carousel.prototype.select = function (index, isWrap) {
    if (!this.active) return;
    var len = this.n;
    var wrapIndex = modulo(index, len);
    var delta = Math.abs(wrapIndex - this.index);
    var back = Math.abs(wrapIndex + len - this.index);
    var fore = Math.abs(wrapIndex - len - this.index);
    if (!this.dragSelect && back < delta) index += len;
    else if (!this.dragSelect && fore < delta) index -= len;
    if (index < 0) this.x -= this.width;
    else if (index >= len) this.x += this.width;
    this.index = modulo(index, len);
    this.markSelected();
    this.setHeight();
    if (REDUCE.matches) {
      this.x = -this.target(this.index);
      this.velocity = 0;
      this.render();
      return;
    }
    this.start();
  };

  Carousel.prototype.start = function () {
    if (this.animating) return;
    this.animating = true;
    this.resting = 0;
    var self = this;
    requestAnimationFrame(function () {
      self.animate();
    });
  };

  // `animate`: drag force, selected attraction, integrate, draw, settle.
  Carousel.prototype.animate = function () {
    if (!this.active || !this.animating) return;
    if (this.pointerDown && this.dragging) this.velocity += this.dragX - this.x - this.velocity;
    if (!this.pointerDown) this.velocity += (-this.target(this.index) - this.x) * ATTRACTION;
    var prev = this.x;
    this.x += this.velocity;
    this.velocity *= 1 - FRICTION;
    this.render();
    if (!this.pointerDown && Math.round(this.x * 100) === Math.round(prev * 100)) this.resting++;
    if (this.resting > 2) {
      this.animating = false;
      return;
    }
    var self = this;
    requestAnimationFrame(function () {
      self.animate();
    });
  };

  // Unidragger + flickity drag: mouse is held (no text select), touch keeps the page's vertical pan.
  Carousel.prototype.pointerStart = function (e) {
    if (e.button !== 0 || this.pointerDown) return;
    if (e.pointerType !== 'touch' && !e.target.matches('input, textarea, select')) e.preventDefault();
    this.row.focus({ preventScroll: true });
    this.pointerId = e.pointerId;
    this.pointerDown = true;
    this.dragging = false;
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.dragX = this.x;
    this.row.classList.add('is-pointer-down');
    window.addEventListener('pointermove', this.onMove);
    window.addEventListener('pointerup', this.onUp);
    window.addEventListener('pointercancel', this.onUp);
  };

  Carousel.prototype.pointerMove = function (e) {
    if (e.pointerId !== this.pointerId) return;
    var dx = e.clientX - this.startX;
    if (!this.dragging) {
      if (Math.abs(dx) <= THRESHOLD) return;
      this.dragging = true;
      this.preventClick = true;
      this.dragStart = this.x;
      this.start();
    }
    e.preventDefault();
    this.previousDragX = this.dragX;
    dx %= this.width;
    this.dragX = this.dragStart + dx * (this.rtl ? -1 : 1);
    this.dragTime = Date.now();
  };

  Carousel.prototype.pointerDone = function () {
    this.pointerDown = false;
    this.row.classList.remove('is-pointer-down');
    window.removeEventListener('pointermove', this.onMove);
    window.removeEventListener('pointerup', this.onUp);
    window.removeEventListener('pointercancel', this.onUp);
  };

  Carousel.prototype.pointerUp = function (e) {
    if (e.pointerId !== this.pointerId) return;
    var wasDragging = this.dragging;
    this.pointerDone();
    this.dragging = false;
    var self = this;
    setTimeout(function () {
      self.preventClick = false;
    });
    if (!wasDragging) return;
    // `dragEndRestingSelect` + `dragEndBoostSelect`
    var index = this.restingSelect();
    if (index === this.index) index += this.boost();
    delete this.previousDragX;
    this.dragSelect = true;
    this.select(index);
    this.dragSelect = false;
  };

  Carousel.prototype.restingSelect = function () {
    var resting = this.x + this.velocity / FRICTION;
    var d = Math.abs(this.distance(-resting, this.index));
    var pos = this.closest(resting, d, 1);
    var neg = this.closest(resting, d, -1);
    return pos.distance < neg.distance ? pos.index : neg.index;
  };

  Carousel.prototype.closest = function (resting, d, step) {
    var k = this.index;
    var best = Infinity;
    while (d < best) {
      k += step;
      best = d;
      d = Math.abs(this.distance(-resting, k));
    }
    return { distance: best, index: k - step };
  };

  Carousel.prototype.boost = function () {
    if (this.previousDragX === undefined || !this.dragTime || Date.now() - this.dragTime > 100) return 0;
    var d = this.distance(-this.dragX, this.index);
    var delta = this.previousDragX - this.dragX;
    if (d > 0 && delta > 0) return 1;
    if (d < 0 && delta < 0) return -1;
    return 0;
  };

  function init(scope) {
    (scope || document).querySelectorAll('[id$="__service_icons_inova"]').forEach(function (root) {
      if (root.svcCarousel) return;
      root.svcCarousel = new Carousel(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
